import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";

declare let $: any;
declare var JitsiMeetExternalAPI;
@Component({
    selector : 'videoconference-screen',
    templateUrl:'videoconference-screen.html'
})
export class VideoconferenceScreenComponent implements OnInit, OnDestroy{

  public api: any;
  public constructor( private _router : Router,public _appData : AppDataService) {
  }
  public ngOnInit(): any {
    if (this.api){  
      this.api.dispose();
    }

    let uid=this._appData.instagramUser.uid;
    let talkTo=this._appData.talkTo.uid;
    var n = uid.localeCompare(talkTo);
    let link='';
    if (n<0){
      link=uid+"_"+talkTo;	
    }else{
      link=talkTo+"_"+uid;
    }
    let querySelector=document.querySelector('#cell-videoconference')
    let room='vipl';
    let  roomlink='https://viplistas.com.br/viplprivatechat_'+link;
    const domain = 'meet.jit.si';
    const options = {
        roomName: roomlink,
        width: '100%',
        height: '100%',
        configOverwrite: { disableDeepLinking: true },
        interfaceConfigOverwrite:{ 
          SHOW_JITSI_WATERMARK: false,
          JITSI_WATERMARK_LINK: 'https://liveparty.com.br',
          SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_BRAND_WATERMARK: false,
          APP_NAME: 'LIVEPARTY',
          TOOLBAR_BUTTONS: [
           'fullscreen','camera'
         ],
    
        SETTINGS_SECTIONS: [ 'devices', 'language', 'moderator', 'profile'],
        MOBILE_DOWNLOAD_LINK_ANDROID: 'https://play.google.com/store/apps/details?id=com.coolkids',
        ANDROID_APP_PACKAGE: 'com.viplistas',
        NATIVE_APP_NAME: 'liveparty',
        enableCalendarIntegration: false,
        BRAND_WATERMARK_LINK: 'https://liveparty.com.br',
        DEFAULT_REMOTE_DISPLAY_NAME: this._appData.instagramUser.full_name,
        DEFAULT_LOCAL_DISPLAY_NAME: 'Eu',
      },

      parentNode: querySelector


    };
    //        interfaceConfigOverwrite:{ MOBILE_APP_PROMO: false},
    this.api = new JitsiMeetExternalAPI(domain, options);
    return true;
  }

  public ngOnDestroy() : any {
    if (this.api){  
       this.api.dispose();
     }
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/videoconference-screen/videconference-screen.ts